import React from 'react';
import { string, shape, arrayOf, func, bool } from 'prop-types';

export default function SingleCheckboxFilter({ filter, classModifier, isChecked, toggleFilters }) {
    return (
        <div className={`single-checkbox-filter ${classModifier}`}>
            <div className="checkbox-wrapper">
                <div className="input-wrapper">
                    <div className="checkbox-item">
                        <input
                            id={filter.label}
                            onChange={e => toggleFilters(e, filter, filter.values[0])}
                            onKeyPress={e => toggleFilters(e, filter, filter.values[0])}
                            type="checkbox"
                            checked={isChecked ? 'checked' : ''}
                        />
                        <label htmlFor={filter.label}>{filter.label}</label>
                    </div>
                </div>
            </div>
        </div>
    );
}

SingleCheckboxFilter.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    filter: shape({
        code: string.isRequired,
        label: string.isRequired,
        values: arrayOf(bool).isRequired
    }).isRequired,
    classModifier: string,
    isChecked: bool.isRequired,
    toggleFilters: func.isRequired
    /* eslint-enable react/no-typos */
};

SingleCheckboxFilter.defaultProps = { classModifier: '' };
